<template>
  <div>
    <div
      class="hidden relative lg:flex items-center bg-indigo-200 overflow-visible rounded-sm h-48 w-full"
    >
      <div class="px-12 cursor-default xl:pr-72">
        <p class="text-4xl text-gray-900">
          {{ infosPass.name }}
        </p>
        <!-- BEGIN Ariane Wire -->
        <div class="inline-flex flex-col xxl:flex-row">
          <div class="text-indigo-600 inline-flex font-light">
            <icon name="layers" />
            <router-link :to="{ name: 'Neopass' }">
              &nbsp;{{
                role === constants.ROLE_BENEFICIAIRE || $freeParticulier()
                  ? 'Mon carnet'
                  : 'Mes carnets'
              }}
              de parcours&nbsp;
            </router-link>
            <span class="hidden xxl:inline-block">>&nbsp;</span>
          </div>
          <span class="text-pink-600 font-light">
            <router-link :to="'/form/neopass/' + infosPass.id_pass">{{
              infosPass.name
            }}</router-link>
            <span class="hidden xxl:inline-block">>&nbsp;</span>
          </span>
          <span class="text-gray-600 font-light"
            >Cartographie individuelle</span
          >
        </div>
        <!-- END Ariane Wire -->
      </div>
      <illustration
        name="cartographie"
        class="hidden xl:block absolute right-5 xl:right-10 w-60 xl:w-72"
      />
    </div>

    <div v-if="allowed">
      <!-- BEGIN List Buttons action -->
      <div class="flex mt-16 mb-16 items-center">
        <action-button
          v-if="$can('cartography_individual_export')"
          class="mr-10"
          border-color="border-transparent"
          text-color="text-gray-900"
          bg-color="bg-indigo-300"
          bg-color-square="bg-indigo-200"
          icon-color="text-indigo-600"
          libelle="Imprimer"
          icon="printer"
        />
        <router-link :to="{ path: '/cartographies/collectives/informations' }">
          <action-button
            v-if="$can(constants.PERMISSION_CARTOGRAPHIE_COLLECTIVE_DISPLAY)"
            class="mr-10"
            border-color="border-transparent"
            text-color="text-gray-900"
            bg-color="bg-pink-300"
            bg-color-square="bg-pink-100"
            icon-color="text-pink-600"
            libelle="Cartographie collective"
            icon="bar-chart-2"
            :enable-action="false"
          />
        </router-link>
      </div>
      <!-- END List Buttons action -->

      <!-- Contenu -->
      <div class="flex flex-col">
        <div
          class="relative align-middle min-w-full shadow sm:rounded-lg border-b border-gray-200 bg-white pb-10 table min-h-halfscreen"
        >
          <router-view />
        </div>
      </div>
      <!-- Fin Contenu -->
    </div>
    <page-not-allowed v-else />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import ActionButton from '../../components/ActionButton';
import Icon from '../../components/Icon';
import Illustration from '../../components/Illustration';

import store from '../../store';
import PageNotAllowed from '../../components/PageNotAllowed';

import Constants from './../../constants';

export default {
  components: {
    ActionButton,
    Icon,
    Illustration,
    PageNotAllowed,
  },

  data() {
    return {
      constants: Constants,
    };
  },

  mounted() {
    store.commit('app/SET_LOADING', false);
  },
  methods: {
    //
  },
  computed: {
    ...mapGetters({
      allowed: 'app/allowed',
      infosPass: 'cartographiesIndividuelles/infosPass',
      role: 'auth/role',
    }),
  },
};
</script>
